import { faBug, faMobileSignalOut, faPalette, faWifiSlash } from '@fortawesome/pro-solid-svg-icons'
import { V2L1AppHeaderSpacer, V2L1AppHeaderTitle } from './V2L1AppHeaderComponents'
import { V2L1AppHeaderFeatureButton } from '../Button/V2L1AppHeaderFeatureButton'
import { V2L1StatusIndicator } from '../Indicator/V2L1StatusIndicator'
import { LocationStatus, StatusIndicatorContext, locationIndicatorProps, syncStatusIndicatorProps } from '../Indicator/StatusIndicatorProps'
import { SyncResultStatus } from '@fusion-advantage/formlib'
import { faStar } from '@fortawesome/pro-regular-svg-icons'
import { V2L2Tooltip } from '../Tooltip/V2L2Tooltip'

interface V2L3DashboardAppHeaderContentProps {
	userFullName: string
	canShowDebugInfo: boolean
	isShowDebugInfo: boolean
	onShowDebugInfoClick?: () => void
	canForceDevRenderer: boolean
	isForceDevRenderer: boolean
	onForceDevRendererClick?: () => void
	canSimulateOffline: boolean
	isSimulateOffline: boolean
	onSimulateOfflineClick?: () => void
	canSetSyncStrategy: boolean
	isMobileSyncStrategy: boolean
	onSyncStrategyClick?: () => void
	locationStatus: LocationStatus|null
	onLocationClick?: () => void
	syncStatus: SyncResultStatus
	onSyncClick?: () => void
	onFeedbackClick?: () => void
}

export const V2L3DashboardAppHeaderContent = ({
	userFullName,
	canShowDebugInfo,
	isShowDebugInfo,
	onShowDebugInfoClick,
	canForceDevRenderer,
	isForceDevRenderer,
	onForceDevRendererClick,
	canSimulateOffline,
	isSimulateOffline,
	onSimulateOfflineClick,
	canSetSyncStrategy,
	isMobileSyncStrategy,
	onSyncStrategyClick,
	locationStatus,
	onLocationClick,
	syncStatus,
	onSyncClick,
	onFeedbackClick,
}: V2L3DashboardAppHeaderContentProps) => {
	return (
		<>
			<V2L1AppHeaderTitle>Hello, {userFullName}</V2L1AppHeaderTitle>
			<V2L1AppHeaderSpacer />
			{canShowDebugInfo ? (
				<V2L2Tooltip tooltip="Debug Mode">
					<V2L1AppHeaderFeatureButton
						icon={faBug}
						active={isShowDebugInfo}
						onClick={onShowDebugInfoClick}
					/>
				</V2L2Tooltip>
			) : null}
			{canForceDevRenderer ? (
				<V2L2Tooltip tooltip="Force Dev Renderer">
					<V2L1AppHeaderFeatureButton
						icon={faPalette}
						active={isForceDevRenderer}
						onClick={onForceDevRendererClick}
					/>
				</V2L2Tooltip>
			) : null}
			{canSimulateOffline ? (
				<V2L2Tooltip tooltip="Simulate Offline">
					<V2L1AppHeaderFeatureButton
						icon={faWifiSlash}
						active={isSimulateOffline}
						onClick={onSimulateOfflineClick}
					/>
				</V2L2Tooltip>
			) : null}
			{canSetSyncStrategy ? (
				<V2L2Tooltip tooltip="Set Sync Strategy">
					<V2L1AppHeaderFeatureButton
						icon={faMobileSignalOut}
						active={isMobileSyncStrategy}
						onClick={onSyncStrategyClick}
					/>
				</V2L2Tooltip>
			) : null}
			<V2L2Tooltip tooltip="Location Status">
				<V2L1AppHeaderFeatureButton
					onClick={onLocationClick}
				>
					<V2L1StatusIndicator
						{...locationIndicatorProps(
							locationStatus,
							StatusIndicatorContext.AppHeaderFeature,
						)}
					/>
				</V2L1AppHeaderFeatureButton>
			</V2L2Tooltip>
			<V2L2Tooltip tooltip="Sync">
				<V2L1AppHeaderFeatureButton
					onClick={onSyncClick}
				>
					<V2L1StatusIndicator
						{...syncStatusIndicatorProps(
							syncStatus,
							StatusIndicatorContext.AppHeaderFeature,
						)}
					/>
				</V2L1AppHeaderFeatureButton>
			</V2L2Tooltip>
			<V2L2Tooltip tooltip="Provide Feedback">
				<V2L1AppHeaderFeatureButton
					active={false} // not sure what to put here or why it would be necessary
					onClick={onFeedbackClick}
				>
					<V2L1StatusIndicator icon={faStar} title='Feedback' />
				</V2L1AppHeaderFeatureButton>
			</V2L2Tooltip>
		</>
	)
}
